// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__gEdIE","label":"Completed_label__2fgRt"};